import {
  ProfitAndLossServiceClient,
  ListProfitAndLossRequest,
  ListDetailsProfitAndLossRequest,
} from '../proto/reportpb/profitandloss_grpc_web_pb';
import { stringToProtoDate, objectToProtoDate } from './ConvertService';
import { auth } from '../lib/auth/Auth';
import { Pagination } from '../proto/utilspb/pagination_pb';

const service = new ProfitAndLossServiceClient(window.env.GRPC_ENDPOINT, {}, { ...auth });

export async function listProfitAndLoss(param, paging) {
  return new Promise((resolve, reject) => {
    let req = new ListProfitAndLossRequest();
    req.setFromDate(stringToProtoDate(param.fromDate));
    req.setToDate(stringToProtoDate(param.toDate));
    req.setCorrespondent(param.correspondent);
    req.setBranch(param.branch);
    req.setAccountNo(param.accountNo);
    req.setMasterAccountNo(param.masterAccountNo);
    req.setRep(param.rep);
    req.setAssetType(param.assetType);
    req.setSymbol(param.symbol);
    req.setOriginalCusip(param.originalCusip);
    req.setPlType(param.plType);

    if (paging) {
      let pg = new Pagination();
      pg.setPageNo(paging.pageNo);
      pg.setPageSize(paging.rowsPerPage);
      pg.setSortName(paging.sortName);
      pg.setSortDirection(paging.sortDirection);
      pg.setFilterNamesList(paging.filterNames);
      pg.setFilterValuesList(paging.filterValues);
      req.setPagination(pg);
    }

    service.listProfitAndLoss(req, {}, (error, response) => {
      if (error) {
        reject(error);
      } else {
        resolve(response.toObject());
      }
    });
  });
}

export async function listDetailsProfitAndLoss(param, paging) {
  return new Promise((resolve, reject) => {
    let req = new ListDetailsProfitAndLossRequest();
    req.setProcessDate(objectToProtoDate(param.processDate));
    req.setAccountId(param.accountId);
    req.setOriginalCusip(param.originalCusip);

    if (paging) {
      let pg = new Pagination();
      pg.setPageNo(paging.pageNo);
      pg.setPageSize(paging.rowsPerPage);
      pg.setSortName(paging.sortName);
      pg.setSortDirection(paging.sortDirection);
      pg.setFilterNamesList(paging.filterNames);
      pg.setFilterValuesList(paging.filterValues);
      req.setPagination(pg);
    }

    service.listDetailsProfitAndLoss(req, {}, (error, response) => {
      if (error) {
        reject(error);
      } else {
        resolve(response.toObject());
      }
    });
  });
}
